import { providePrimeNG } from 'primeng/config';

import { provideAnimations } from '@angular/platform-browser/animations';
import { withInterceptors, provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { MessageService } from 'primeng/api';
import { NamedRouterModule } from '@/app/core/services/named-router/named-router.module';

import { SvgIconModule } from '@/app/shared/components/ui/svg-icon';

import { AppRoutes } from '@/app/core/routes';
import { authInterceptor, refreshInterceptor } from '@/app/core/interceptors';

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor, refreshInterceptor])),
    providePrimeNG({
      translation: {
        firstDayOfWeek: 1,
        dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      },
    }),
    importProvidersFrom(
      SvgIconModule.forRoot({
        spriteUrl: '/assets/icons/sprite.svg',
      }),
      NamedRouterModule.forRoot(AppRoutes),
    ),
  ],
};
